import { noCacheHeaders } from '@/services/_api/helpers'
import useUrl from './helpers/useUrl'

/** @param {import('@nuxtjs/axios').NuxtAxiosInstance} client */
export default (client) => {
  const root = useUrl('promocodes')

  return {
    /** @returns {Promise<AxiosResponse<GetActivationInfoResponse>>} */
    getActivationInfo() {
      const url = root('curiosities_list')
      return client.get(url, { headers: noCacheHeaders })
    },

    /** @param {Object} PromocodeDTO
      * @param {string} [PromocodeDTO.code='']
      *
      * @returns {Promise<AxiosResponse<ActivatePromocodeResponse>>} */
    promocode({ code = '' }) {
      const url = root('activate')
      return client.post(url, { code })
    },
  }
}

/**
 * @typedef {object} GetActivationInfoResponse
 * @prop {string} status
 * @prop {InterestringPromocode[]} promocodes
 * */

/**
 * @typedef {Object} InterestringPromocode
 * @property {boolean} isActive - A boolean field indicating whether the promocode is currently active. A promocode is considered active if the current date is within its start_date and end_date.
 * @property {boolean} isUserActivated -  A boolean field indicating whether the user has already activated the promocode.
 * @property {string} promocode - The actual code of the promocode that the user may apply (e.g., LEVELUP, BMBONUS).
 * @property {string} promocodeType - Represents type of the promocode (e.g., level, bonus_machine, verification, etc.).
 * */

/** @typedef {object} ActivatePromocodeResponse
 * @property {boolean} status
 * @property {boolean} includesDepositPromotions
 * @property {object[]} promotions
 * @property {string} promotions.code
 * @property {string} promotions.type
 * @property {string} promotions.activation_type
 * @property {boolean} promotions.is_welcome_pack
 * @property {boolean} promotions.is_promocode
 * @property {number} promotions.activation_count
 * @property {string} promotions.end_date
 * @property {object} promotions.ru
 * @property {string} promotions.ru.title
 * @property {string} promotions.ru.description
 * @property {string} promotions.ru.short_description
 * @property {string} promotions.ru.description_app
 * @property {string} promotions.ru.short_description_app
 * @property {string} promotions.ru.terms
 * @property {object} promotions.ru.image
 * @property {string} promotions.ru.image.desktop
 * @property {string} promotions.ru.image.mobile
 * @property {string} promotions.ru.button1
 * @property {string} promotions.ru.button2
 * @property {string} promotions.ru.url1
 * @property {string} promotions.ru.url2
 * @property {object} promotions.ua
 * @property {string} promotions.ua.title
 * @property {string} promotions.ua.description
 * @property {string} promotions.ua.short_description
 * @property {string} promotions.ua.description_app
 * @property {string} promotions.ua.short_description_app
 * @property {string} promotions.ua.terms
 * @property {object} promotions.ua.image
 * @property {string} promotions.ua.image.desktop
 * @property {string} promotions.ua.image.mobile
 * @property {string} promotions.ua.button1
 * @property {string} promotions.ua.button2
 * @property {string} promotions.ua.url1
 * @property {string} promotions.ua.url2
 * @property {} promotions.groups
 * @property {} promotions.bonus
 * @property {null} promotions.level_gift_info
 * @property {number} promotions.min_deposit
 */
